import { createElement } from 'react';
import { useThemeUI, STATUSES, Pane, utils, Icon, Box, Text, Button } from '@costar/theme-ui';

var Toast = function Toast(props) {
  var _props$status = props.status,
    status = _props$status === void 0 ? 'info' : _props$status,
    variant = props.variant,
    id = props.id,
    title = props.title,
    isClosable = props.isClosable,
    onClose = props.onClose,
    description = props.description;
  var _useThemeUI = useThemeUI(),
    theme = _useThemeUI.theme; // change to usesafethemeui
  var _STATUSES$status = STATUSES[status],
    icon = _STATUSES$status.icon,
    color = _STATUSES$status.color;
  return /*#__PURE__*/createElement(Pane, {
    variant: variant,
    id: "".concat(id),
    fontFamily: "body",
    display: "flex",
    justifyContent: "space-between",
    gap: "sm",
    border: "shadow",
    alignContent: "center",
    borderRadius: "md",
    elevation: 300,
    p: "md",
    width: "auto",
    bg: utils.getSafeTint(0.8, utils.getSafeColor(color, theme))
  }, /*#__PURE__*/createElement(Icon, {
    icon: icon,
    size: "md",
    color: color
  }), /*#__PURE__*/createElement(Box, {
    flex: "1",
    maxWidth: "100%"
  }, title && /*#__PURE__*/createElement(Text, null, title), description && /*#__PURE__*/createElement(Box, null, description)), isClosable && /*#__PURE__*/createElement(Button, {
    variant: "icon",
    p: "0",
    size: "xxs",
    icon: "close",
    color: "neutral.darker",
    onClick: onClose,
    position: "absolute",
    top: "0.5rem",
    right: "0.5rem"
  }));
};

export { Toast };
//# sourceMappingURL=toast-component.esm.js.map
